import styled, { css, keyframes } from 'styled-components';
import { rgba } from 'polished';
import { px2rem } from '../../helpers/rem.mjs';
import { BaseButton } from './base.mjs';
import { MEDIA_QUERY } from '../../constants/responsive.mjs';
export { IconButton } from './icon.mjs';

var FlatButton = styled(BaseButton).attrs(function (props) {
  return {
    loaderColor: props.theme.colorV2.colorSet.white1000
  };
}).withConfig({
  displayName: "FlatButton",
  componentId: "sc-1h8wqo0-0"
})(["", ""], function (props) {
  var _a;
  var palette = props.theme.getButtonElementPalette("button");
  var paletteColor = (_a = palette.color) !== null && _a !== void 0 ? _a : props.theme.colorV2.primary.main;
  return css(["border:1px solid ", ";background-color:", ";color:", ";", ""], paletteColor, paletteColor, palette.fog800, props.isActive ? css(["border:1px solid ", ";background-color:", ";color:", ";"], rgba(paletteColor, 0.14), rgba(paletteColor, 0.14), paletteColor) : null);
});
var FlatGeneralButton = styled(BaseButton).attrs(function (props) {
  return {
    loaderColor: props.theme.colorV2.colorSet.white1000
  };
}).withConfig({
  displayName: "FlatGeneralButton",
  componentId: "sc-1h8wqo0-1"
})(["background-color:", ";color:", ";border:1px solid ", ";", ""], function (props) {
  return props.theme.colorV2.colorSet.grey800;
}, function (props) {
  return props.theme.colorV2.colorSet.white1000;
}, function (props) {
  return props.theme.colorV2.colorSet.grey800;
}, function (props) {
  if (props.isActive) {
    return "\n        border: 1px solid ".concat(props.theme.colorV2.colorSet.grey50, ";\n        background-color: ").concat(props.theme.colorV2.colorSet.grey50, ";\n        color: ").concat(props.theme.colorV2.colorSet.grey800, ";\n      ");
  }
});
var GhostButton = styled(BaseButton).withConfig({
  displayName: "GhostButton",
  componentId: "sc-1h8wqo0-2"
})(["", ""], function (props) {
  var _a;
  var palette = props.theme.getButtonElementPalette("button");
  var paletteColor = (_a = palette.color) !== null && _a !== void 0 ? _a : props.theme.colorV2.primary.main;
  return css(["background-color:transparent;color:", ";border:", " solid ", ";", ""], paletteColor, px2rem(1), paletteColor, function () {
    if (props.isActive) {
      return "\n        color: ".concat(paletteColor, ";\n        background-color: ").concat(rgba(paletteColor, 0.14), ";\n        border: 1px solid transparent;\n      ");
    }
  });
});
var GhostGeneralButton = styled(BaseButton).attrs(function (props) {
  return {
    loaderColor: props.theme.colorV2.colorSet.grey800
  };
}).withConfig({
  displayName: "GhostGeneralButton",
  componentId: "sc-1h8wqo0-3"
})(["background-color:transparent;color:", ";border:", " solid ", ";", ""], function (props) {
  return props.theme.colorV2.colorSet.grey800;
}, px2rem(1), function (props) {
  return props.theme.colorV2.colorSet.grey100;
}, function (props) {
  if (props.isActive) {
    return "\n        background-color: ".concat(props.theme.colorV2.colorSet.grey50, ";\n        border: 1px solid transparent;\n      ");
  }
});
var TextButton = styled(BaseButton).withConfig({
  displayName: "TextButton",
  componentId: "sc-1h8wqo0-4"
})(["", " background-color:transparent;", ""], function (props) {
  var _a;
  var palette = props.theme.getButtonElementPalette("button");
  var paletteColor = (_a = palette.color) !== null && _a !== void 0 ? _a : props.theme.colorV2.primary.main;
  return css(["color:", ";"], paletteColor);
}, function (props) {
  return props.direction && css(["padding-", ":0;text-align:", ";"], props.direction, props.direction);
});
var TextGeneralButton = styled(BaseButton).attrs(function (props) {
  return {
    loaderColor: props.theme.colorV2.colorSet.grey800
  };
}).withConfig({
  displayName: "TextGeneralButton",
  componentId: "sc-1h8wqo0-5"
})(["background-color:transparent;color:", ";", " ", ""], function (props) {
  return props.theme.colorV2.colorSet.grey800;
}, function (props) {
  return props.direction && css(["padding-", ":0;text-align:", ";"], props.direction, props.direction);
}, function (props) {
  if (props.isActive) {
    return "\n        color: ".concat(props.theme.colorV2.primary.main, ";\n        background-color: ").concat(rgba(props.theme.colorV2.primary.main, 0.14), ";\n        border: 1px solid transparent;\n      ");
  }
});
var FloatActionButton = styled(BaseButton).withConfig({
  displayName: "FloatActionButton",
  componentId: "sc-1h8wqo0-6"
})(["min-width:initial;width:", ";height:", ";background-color:", ";color:", ";border-radius:50%;display:flex;align-items:center;justify-content:center;"], px2rem(48), px2rem(48), function (props) {
  return props.theme.colorV2.primary.main;
}, function (props) {
  return props.theme.colorV2.colorSet.white1000;
});
var shinyButtonAnimation = keyframes(["0%{transform:translateX(-100%);transition-property:left;}100%{transform:translateX(100%);transition-property:left;}"]);
var shinyAnimation = css(["@media ", "{position:relative;overflow:hidden;&:before{content:\"\";position:absolute;top:0;width:100%;height:100%;background-image:linear-gradient( 120deg,", "30%,", ",", "70% );opacity:0;transform:translateX(-100%);transition:transform 2s ease-in-out;}}"], MEDIA_QUERY.EXCEPT_MOBILE, function (props) {
  return rgba(props.theme.themeMode.lightPalette.colorSet.white1000, 0);
}, function (props) {
  return rgba(props.theme.themeMode.lightPalette.colorSet.white1000, 0.5);
}, function (props) {
  return rgba(props.theme.themeMode.lightPalette.colorSet.white1000, 0);
});
var alwaysShinyAnimationButtonStyle = css(["--animation-always:true;", ";opacity:1;&:before{opacity:1;animation:", " 2s ease-in-out infinite;}"], shinyAnimation, shinyButtonAnimation);
var shinyAnimationButtonStyle = css(["", ";@media ", "{&:hover{opacity:1;&:before{opacity:1;animation:", " 1s ease-in-out infinite;}}}"], shinyAnimation, MEDIA_QUERY.EXCEPT_MOBILE, shinyButtonAnimation);

export { BaseButton, FlatButton, FlatGeneralButton, FloatActionButton, GhostButton, GhostGeneralButton, TextButton, TextGeneralButton, alwaysShinyAnimationButtonStyle, shinyAnimation, shinyAnimationButtonStyle };
